import { render } from "./Main.vue?vue&type=template&id=a9cb380a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=a9cb380a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9cb380a"

export default script